import React, { useEffect, useReducer, useState } from "react"
import { obterMensagensIzza } from "../../../services/enviosIzza"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { VerEnviosIzzaInicial } from "../models/verEnviosIzzaModel"
import { VerEnviosIzzaActionsTypes } from "./verEnviosIzzaActions"
import { VerEnviosIzzaContext } from "./VerEnviosIzzaContext"
import { verEnviosIzzaReducer } from "./verEnviosIzzaReducer"

export function VerEnviosIzzaContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(verEnviosIzzaReducer, VerEnviosIzzaInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterMensagensIzza(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar mensagens")
            } else {
                setErroCarregamento(null)
                dispatch({ type: VerEnviosIzzaActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar mensagens")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <VerEnviosIzzaContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </VerEnviosIzzaContext.Provider>
    )
}
